import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import API from '../../config/api';
const API_URL = API.EVALUATIONS;

// ✅ Récupérer toutes les évaluations
export const fetchEvaluations = createAsyncThunk('evaluations/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem('token'); // 🔥 Récupère le token
    if (!token) throw new Error("Token manquant");

    const response = await axios.get(API_URL, {
      headers: { Authorization: `Bearer ${token}` } // 🔥 Ajoute le token JWT
    });

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Erreur inconnue");
  }
});

const evaluationSlice = createSlice({
  name: 'evaluations',
  initialState: { list: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvaluations.pending, (state) => { state.status = 'loading'; })
      .addCase(fetchEvaluations.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = action.payload;
      })
      .addCase(fetchEvaluations.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default evaluationSlice.reducer;
